import { LayoutDashboard, Building, Users, User } from "lucide-react";
import { ROUTES } from "@/app/routes";
import type { NavItem } from "@/components/shared/navigation/hooks/useNavState";
import type { SidebarVariant } from "@/components/shared/navigation/Sidebar/sidebarTheme";
import type { TFunction } from "i18next";

export interface AppLayoutConfig {
	/** Sidebar theme variant */
	variant: SidebarVariant;
	/** Static nav items — overrides factory when provided */
	navItems?: NavItem[];
	/** Factory to build nav items (receives `t` for i18n) */
	getNavItems?: (t: TFunction) => NavItem[];
	/** Show org selector in sidebar (DashboardLayout) */
	enableOrgContext?: boolean;
	/** Show AI chat widget (DashboardLayout) */
	enableAiChat?: boolean;
	/** Enable hub profile switching */
	enableProfileSwitching?: boolean;
	/** Enable mobile-specific layout (bottom nav, mobile header) */
	enableMobileLayout?: boolean;
	/** Hide the search input in TopBar */
	disableSearch?: boolean;
}

export function getAdminNavItems(t: TFunction): NavItem[] {
	return [
		{
			path: ROUTES.ADMIN.DASHBOARD,
			icon: <LayoutDashboard size={16} />,
			label: t("admin.nav.dashboard"),
		},
		{
			path: ROUTES.ADMIN.ORGANIZATIONS,
			icon: <Building size={16} />,
			label: t("admin.nav.organizations"),
		},
		{
			path: ROUTES.ADMIN.USERS,
			icon: <Users size={16} />,
			label: t("admin.nav.users"),
		},
	];
}

export function getHubNavItems(t: TFunction): NavItem[] {
	return [
		{
			path: ROUTES.HUB.DASHBOARD,
			icon: <LayoutDashboard size={16} />,
			label: t("hub.nav.dashboard"),
		},
		{
			path: ROUTES.HUB.PROFILE,
			icon: <User size={16} />,
			label: t("hub.nav.profile"),
		},
	];
}

export const DASHBOARD_LAYOUT: AppLayoutConfig = {
	variant: "default",
	enableOrgContext: true,
	enableAiChat: true,
};

export const ADMIN_LAYOUT: AppLayoutConfig = {
	variant: "admin",
	getNavItems: getAdminNavItems,
	disableSearch: true,
};

export const HUB_LAYOUT: AppLayoutConfig = {
	variant: "hub",
	getNavItems: getHubNavItems,
	enableProfileSwitching: true,
	enableMobileLayout: true,
	disableSearch: true,
};
